
import Header from "@/components/TheHeader.vue";
import { defineAsyncComponent, defineComponent } from "vue";
import { mapGetters } from "vuex";
export default defineComponent({
  computed: {
    ...mapGetters({
      snack: "getSnack",
    }),
  },
  components: {
    Header,
    AppSnack: defineAsyncComponent(() => import("@/components/AppSnack.vue")),
  },
});
